import { ModelCellProps } from "../../../../config/modelsConfig";
import React from "react";
import { VLMPrediction } from "../../../../models/log";

export const VLMCell: React.FC<ModelCellProps> = (props) => {
  const p = props.prediction as VLMPrediction;
  const { answer } = p;
  return <span>{answer === null ? "-" : answer ? "True" : "False"}</span>;
};
